import {IntermediatePart} from "../../parts/intermediatePart";

export default class BathTubTowelRack extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'bathtub_towel_rack';
    this.translateId = "visualizer.bathroom.bathtub.bathtub_towel_rack";
    this.partName = 'Towel Rack';
    this.visible = [];
    // this.visible = [BathTubType.Custom60in, BathTubType.FreeStanding];
  }

  load(dbFeature) {
    return super.load_(dbFeature, new BathTubTowelRack());
  }

  setZIndex(zIndexes) {
    // if (layout.type === LayoutType.Large) {
    //     this.activeFeature.layer.zIndex = Z.layouts.Large.Towel_Rack;
    // } else {
    //     Exception.NotImplemented();
    // }
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Towel_Rack;
    }
  }
}
